<div id="top"></div>
<app-header></app-header>
<div style=" text-align: center; padding: 50px;">
    <img src="assets/informatie/verkoopspunten.jpg" alt="">  
</div>
<app-insta-two></app-insta-two>
<app-footer (to_top)="to_top()"></app-footer>
